import {apiPost} from './api.client';
import {lexVersion} from './variables';

function getHostPath() {
// Window doesn't exist server side so this is needed, we need to pass a valid host name or component will not load in catalyst app!
    let hostPath = (typeof window !== 'undefined') && (typeof window.location !== 'undefined') && (typeof window.location.origin) !== 'undefined' ?
        window.location.origin :
        'http://localhost:8080';
    return hostPath;
}

function loadConfig(locale, context) {
    let hostPath = getHostPath();
    let configUrl = `${hostPath}/auth/ui/lex/config?context=${context}`;
    let options = {locale, lexVersion};
    return new Promise((resolve) => {
        apiPost(configUrl, options)
            .then((response) => {
                if (response.status === 200) {
                    response.json().then(resolve);
                } else {
                    resolve({});
                }
            })
            .catch(() => {
                resolve({});
            });
    });
}

function isProductionEnvironment() {
    let hostPath = getHostPath();
    return !(hostPath.startsWith('http://local')
        || hostPath.startsWith('https://test.')
        || hostPath.startsWith('https://stage.')
        || hostPath.startsWith('http://10.0.2.2:'));
}

export {
    loadConfig,
    isProductionEnvironment
};
